import { cn } from '@/lib/utils'
import type { VisualToolsState } from '@/hooks/useVisualTools'
import { PresentTextCard } from './PresentTextCard'
import { ShadowPracticeCard } from './ShadowPracticeCard'
import { CorrectionWidget } from './CorrectionWidget'
import { AccomplishmentCelebration } from './AccomplishmentCelebration'

interface VisualToolsOverlayProps {
  state: VisualToolsState
  onClear: () => void
  className?: string
}

export function VisualToolsOverlay({ state, onClear, className }: VisualToolsOverlayProps) {
  // Don't render if nothing to show
  if (!state.activeType) {
    return null
  }

  return (
    <div
      className={cn(
        'w-full max-w-md mx-auto',
        className
      )}
    >
        {/* Present Text Card */}
        {state.activeType === 'present' && state.presentText && (
          <PresentTextCard
            data={state.presentText}
            onClose={onClear}
          />
        )}

        {/* Shadow Practice Card */}
        {state.activeType === 'shadow' && state.shadowPractice && (
          <ShadowPracticeCard
            data={state.shadowPractice}
            onClose={onClear}
          />
        )}

        {/* Correction Widget */}
        {state.activeType === 'correction' && state.correction && (
          <CorrectionWidget
            data={state.correction}
            onClose={onClear}
          />
        )}

        {/* Accomplishment Celebration */}
        {state.activeType === 'accomplishment' && state.accomplishment && (
          <AccomplishmentCelebration
            data={state.accomplishment}
          />
        )}
    </div>
  )
}
